export const WAREHOUSELIST = "wareHouselist";
export const WAREHOUSELIST_SUCCESSFULL = "wareHouselist_successfull";
export const CREATE_WAREHOUSE = "create_warehouse";
export const CREATE_WAREHOUSE_SUCCESSFULL = "create_warehouse_successfull";
export const UPDATE_WAREHOUSE = "update_warehouse";
export const UPDATE_WAREHOUSE_SUCCESSFULL = "update_warehouse_successfull";